"use client";

import type { PracticeMode } from "@/lib/atsa/atsaConfig";

export function ModeSelector({ value, onChange }: { value: PracticeMode; onChange: (mode: PracticeMode) => void }) {
  return (
    <div className="mode-selector" role="group" aria-label="Practice mode">
      <button type="button" className={value === "training" ? "active" : ""} onClick={() => onChange("training")}>
        Training
        <small>Feedback and adjustable timing</small>
      </button>
      <button type="button" className={value === "simulation" ? "active" : ""} onClick={() => onChange("simulation")}>
        Fidelity simulation
        <small>No feedback and reported controls</small>
      </button>
    </div>
  );
}
